import { CrisisProgramSelectionScreen } from '@/components/CrisisProgramSelectionScreen';

export default function CrisisProgramSelection() {
  return <CrisisProgramSelectionScreen />;
}
